import { Component, OnInit } from "@angular/core";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as  _ from 'lodash';
import { HelperService, AlertService } from '../../../services';
import { AppState, AppFields } from '../../../store';
import * as lodash from "lodash";
import { ClubTeamsService } from "../../../services/club-teams.service";
@Component({
  selector: "app-our-system-status",
  templateUrl: "./our-system-status.component.html",
  styleUrls: ["./our-system-status.component.css"]
})

export class OurSystemStatusComponent implements OnInit {
  public PageName = "System Status";
  HisrotyList: any[] = []
  public breadCrumbLinks: any[] = [];
  tgsSystemID: number;
  title: string;
  constructor(
    private fb: FormBuilder,
    private loader: Ng4LoadingSpinnerService,
    private helperService: HelperService,
    private alertService: AlertService,
    private store: Store<AppState>,
    private service: ClubTeamsService,
  ) {
    this.store.select(AppFields.App, AppFields.EvalautionAccount).subscribe((team) => {
      if (team) {
        this.tgsSystemID = 2;
        this.title = "Team";
      } else {
        this.tgsSystemID = 1;
        this.title = "Club";
      }
    });
  }

  ngOnInit() {
    this.breadCrumbLinks = [
      { title: 'System Status', url: '' }
    ];
    this.loader.show();
    this.getTGSSystemOverallStatusList();
  }
  linksData: any
  getTGSSystemOverallStatusList() {
  
    this.service.getTGSSystemOverallStatusList().subscribe((rs: any) => {
      this.onClickOverAllEdit(this.tgsSystemID);
      if (rs && rs.data)
        this.linksData = rs.data.filter(x => x.tgsSystemID == this.tgsSystemID)[0];
    }, error => {
      console.log(error);
      this.loader.hide();
      this.alertService.error(error.error);
    });
  }

  toggleClass(e, c, tgsSystemIssueID: number,index:number) {

    const hasClass = e.target.classList.contains(c);

    if (hasClass) {
      this.onClickEdit(tgsSystemIssueID,index);
      e.target.classList.remove('fa-angle-down')
      e.target.classList.add('fa-angle-up')
    } else {
      e.target.classList.add('fa-angle-down')
      e.target.classList.remove('fa-angle-up')
    }
  }

  systemData: any[] = [];
  onClickOverAllEdit(tgsSystemID: number) {
    this.service.getAllIssueByTGSSystemID(tgsSystemID).subscribe((rs: any) => {
      if (rs) {
        this.systemData = rs.data;
      }
      this.loader.hide();
    }, error => {
      console.log(error);
      this.loader.hide();
      this.alertService.error(error.error);
    });
  }

  HisrotyDataList: any[] = [];
  onClickEdit(tgsSystemIssueID: number, index:number) {
    this.loader.show();
    this.service.getTGSSystemIssueHistoryByIssueID(tgsSystemIssueID).subscribe((rs: any) => {
      this.loader.hide();
      if (rs && rs.data) {
        this.HisrotyList = lodash.orderBy(rs.data.tgsSystemIssueHistoryByIssueIDList, ['dateAdded'], 'desc');
        this.HisrotyDataList[index] = this.HisrotyList
      }
    }, error => {
      console.log(error);
      this.loader.hide();
      this.alertService.error(error.error);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/our-system-status/our-system-status.component.ts